import { render } from "./OverlayModal.vue?vue&type=template&id=a1719d90&scoped=true&ts=true"
import script from "./OverlayModal.vue?vue&type=script&lang=ts"
export * from "./OverlayModal.vue?vue&type=script&lang=ts"

import "./OverlayModal.vue?vue&type=style&index=0&id=a1719d90&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1719d90"]])

export default __exports__